module.exports = __webpack_public_path__ + "img/mock-logo.dffe52.png";